<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="vendor_shop_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Vendor Shops</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'Vendor Shops')"><v-icon
                  color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on }">
                <v-btn class="mt-4 button" v-on="on" small>Add Vendor Shop</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" class="pb-0">
                          <b>Vendor</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                          <v-autocomplete dense required v-model="editedItem.vendor_id" :items="vendor_list"
                            item-text="vendor_name" :rules="[(v) => !!v || 'required']" item-value="vendor_id" outlined
                            persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                          <b>Shop Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field v-model="editedItem.name" persistent-hint :rules="[(v) => !!v || 'required']"
                            outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                          <b>Address</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                          <v-textarea v-model="editedItem.address" persistent-hint :rules="[(v) => !!v || 'required']"
                            outlined dense></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                          <b>Email</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field v-model="editedItem.contact_email" persistent-hint
                            :rules="[rules.required, rules.email]" outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                          <b>Mobile</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field v-model="editedItem.contact_mobile" persistent-hint type="number" min="0"
                            @keypress="onlyNumbers"
                            :rules="true?[
                            v => !!v || 'Mobile Number is required',
                            v => (v && v.length == 10) || 'Mobile Number Must be 10 digit'
                            ]:[v => ((v==null || v=='')?true:(v.length==0||v.length == 10))  || 'Mobile Number Must be 10 digit']" outlined
                            dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                          <b>Business Hours</b>
                          <v-textarea class="pt-2" v-model="editedItem.business_hours" persistent-hint outlined
                            dense></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                          <b>Latitude</b>
                          <v-text-field class="pt-2" v-model="editedItem.latitude" persistent-hint outlined
                            dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                          <b>Longitude</b>
                          <v-text-field class="pt-2" v-model="editedItem.longitude" persistent-hint outlined
                            dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" color="primary" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.delete="{ item }">
          <div>
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="v-icon-size" color="red" @click="deleteItem(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
        </template>

        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Vendor Shop", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style2",
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Sr.No",
        align: "left",
        sortable: false,
        value: "sr_no",
      },
      {
        text: "Vendor",
        align: "left",
        sortable: true,
        value: "vendor",
      },
      {
        text: "Shop Name",
        align: "left",
        sortable: true,
        value: "name",
      },
      {
        text: "Address",
        align: "left",
        sortable: true,
        value: "address",
      },
      {
        text: "Email",
        align: "left",
        sortable: true,
        value: "contact_email",
      },
      {
        text: "Mobile",
        align: "left",
        sortable: true,
        value: "contact_mobile",
      },
      {
        text: "Business Hours",
        align: "left",
        sortable: true,
        value: "business_hours",
      },
      {
        text: "Latitude",
        align: "left",
        sortable: true,
        value: "latitude",
      },
      {
        text: "Longitude",
        align: "left",
        sortable: true,
        value: "longitude",
      },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      vendor_id:"",
      isactive: true,
    },
    defaultItem: {
      id: "",
      name: "",
      vendor_id:"",
      isactive: true,
    },
    vendor_shop_list:[],
    rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        mobile: (value) => {
          const pattern = /[0-9]{10}/;
          return pattern.test(value);
        },
      },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add New Vendor Shop" : "Edit Vendor Shop";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onlyNumbers(event) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  },
    fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Vendor</th>
            <th>Shop Name</th>
            <th>Address</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Business Hours</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Status</th>
            </tr>`;

                this.vendor_shop_list.forEach((s) => {
                    let isactive = s.isactive ? 'Yes' : 'No';
                    tab_text += `
            <tr>
                <td>${s.sr_no}</td>
                <td>${s.vendor}</td>
                <td>${s.name}</td>
                <td>${s.address}</td>
                <td>${s.contact_email}</td>
                <td>${s.contact_mobile}</td>
                <td>${s.business_hours}</td>
                <td>${s.latitude}</td>
                <td>${s.longitude}</td>
                <td>${isactive}</td>
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
    },
    editItem(item) {
      this.editedIndex = this.vendor_shop_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/EduStore/editVendorShop", this.editedItem)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.onLoad();
                                Object.assign(this.vendor_shop_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Vendor Shop is Updated Successfully...");
                            }
                            else if(res.data.flag == "NO") {
                              this.showSnackbar("error", res.data.msg)
                            }                          
                        })
                        .catch((error) => {
                            this.showSnackbar("error", "Something went wrong...");
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                axios
                    .post("/EduStore/saveVendorShop", this.editedItem)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            //window.alert(res.data.status.code)
                            this.vendor_shop_list.push(this.editedItem);
                            this.showSnackbar("#4caf50", "Vendor Shop is Added Successfully...");
                            this.onLoad();
                        } else if (res.data.code == "NA") {
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "Vendor Shop is Already Present!!!"); 
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("error", "Something went wrong...");
                        window.console.log(error);
                    });
                this.close();
            }
        },
    onLoad() {
      this.overlay = true;
            axios
                .post("/EduStore/getVendorShop")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.vendor_shop_list = res.data.vendor_shop_list;
                        this.vendor_list = res.data.vendor_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
    },
    deleteItem(item) {
    if (!confirm("Are You Sure You Want To Delete ...?")) return;
    const formData = {
        id: item.id,
    };

    axios
        .post("/EduStore/deleteVendorShop", formData)
        .then((res) => {
            if (res.data.status == "YES") {
                this.showSnackbar("#4caf50", "Vendor Shop Deleted Successfully...");

                this.onLoad();
            } else {
                this.showSnackbar("#b71c1c", "Something went wrong...");
            }
        })
        ;
    },
    toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/EduStore/toggleVendorShop", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Vendor Shop status Changed Successfully !"); 
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    this.showSnackbar("#4caf50", "Something went wrong");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>
